import { render, staticRenderFns } from "./item_former.vue?vue&type=template&id=62849fc2&"
import script from "./item_former.vue?vue&type=script&lang=js&"
export * from "./item_former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports